import { SELECTORS } from '$utils/constants';

export const setLocation = () => {
  const audienceLocationValue = document.querySelector(
    SELECTORS.audienceLocationValue
  ) as HTMLElement;
  localStorage.setItem('location', audienceLocationValue.innerText);
};

export const getLocation = () => {
  const resultAudienceLocation = document.querySelector(
    SELECTORS.resultAudienceLocation
  ) as HTMLElement;
  const location = localStorage.getItem('location');
  if (location) {
    resultAudienceLocation.innerText = location;
    localStorage.removeItem('location');
  }
};
